export const UPDATE_VIEWCOUNT = "UPDATE_VIEWCOUNT";